import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import NavLink from '../../../global/NavLink';

const StyledP = styled.p`
  line-height: 14px;
  margin: 0;
  max-width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Wrapper = styled(NavLink)`
  color: ${p => p.theme.color.textSecondary};
  border-bottom: 1px solid ${p => p.theme.color.borderPrimary};
  display: flex;
  font-family: ${p => p.theme.font.sourceSans};
  font-size: 14px;
  font-weight: ${p => p.theme.fontWeight.semibold};
  justify-content: space-between;
  line-height: 1;
  padding: 16px 19px 16px 48px;

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: ${props => props.theme.deviceWidth.largePhone}) {
    font-size: 12px;
    padding: 16px 0;
  }
`;

const File = ({ name, size, to }) => (
  <Wrapper to={to}>
    <StyledP>{name}</StyledP>
    <StyledP>{size}</StyledP>
  </Wrapper>
);

File.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.string,
  to: PropTypes.string.isRequired
};

export default File;
